/** @format */

import { defaultActions } from '../../core/actionsDefault';

// const _ = require('underscore');

export const geoLocationStateConstants = {
    LIST: 'geo_location_state_list',
    SELECT_CHANGE: 'geo_location_state_select',
};

export class geoLocationStateActions extends defaultActions {}
